/*
 * Вкладки раздела «Администрирование» и их страницы (решение Ильи 19.09.2026).
 *
 * Группа — уровень интерфейса, а не запись реестра доступов: своего кода у неё
 * нет, разделами она стать не может (реестр не пускает разделы глубже двух
 * уровней, `server/src/access/registry.ts`). Доступом закрыта каждая страница
 * по отдельности; группа видна, если открыта хотя бы одна её страница.
 *
 * Таблица лежит отдельно от экрана, чтобы её могли читать проверки: список
 * кодов для пункта меню собирается отсюда же, а `admin.test.ts` сверяет её с
 * реестром — раздел `section.admin.*`, заведённый в реестре и забытый здесь,
 * роняет тест, а не исчезает из админки молча.
 */

/** Страница администрирования: одна вкладка или один пункт внутри группы. */
export type AdminPage = { key: string; title: string; code: string };

export type AdminTab = { key: string; title: string; pages: AdminPage[] };

export const ADMIN_TABS: AdminTab[] = [
  {
    key: 'team',
    title: 'Команда',
    pages: [
      { key: 'employees', title: 'Сотрудники', code: 'section.admin.employees' },
      { key: 'org', title: 'Оргструктура', code: 'section.admin.org' },
    ],
  },
  {
    // Обе страницы закрыты одним кодом: мобильная раздача — тот же доступ,
    // только с другой стороны, отдельного раздела реестра у неё нет.
    key: 'access',
    title: 'Доступы',
    pages: [
      { key: 'processes', title: 'Бизнес-процессы', code: 'section.admin.access' },
      { key: 'mobile', title: 'Мобильные доступы', code: 'section.admin.access' },
    ],
  },
  {
    key: 'reference',
    title: 'Справочники',
    pages: [
      { key: 'cats', title: 'Виды работ', code: 'section.admin.categories' },
      { key: 'criteria', title: 'Критерии проверок', code: 'section.admin.criteria' },
    ],
  },
  {
    key: 'settings',
    title: 'Общие настройки',
    pages: [
      { key: 'calendar', title: 'Производственный календарь', code: 'section.admin.calendar' },
      { key: 'rooms', title: 'Переговорные', code: 'section.admin.rooms' },
      { key: 'server', title: 'Сервер', code: 'section.admin.server' },
      { key: 'services', title: 'Внешние сервисы', code: 'section.admin.services' },
      { key: 'payments', title: 'Платежи', code: 'section.admin.payments' },
      { key: 'helper', title: 'Вопросы помощнику', code: 'section.admin.helper' },
    ],
  },
  {
    key: 'sla',
    title: 'Соблюдение сроков',
    pages: [{ key: 'sla', title: 'Соблюдение сроков', code: 'section.admin.sla' }],
  },
];

/** Хотя бы одна из этих записей должна быть доступна, чтобы показать «Администрирование». */
export const ADMIN_SECTION_CODES = [
  ...new Set(ADMIN_TABS.flatMap((t) => t.pages.map((p) => p.code))),
];
